import { render, staticRenderFns } from "./AtTranslationTabs.vue?vue&type=template&id=822ae828&scoped=true&"
import script from "./AtTranslationTabs.vue?vue&type=script&lang=js&"
export * from "./AtTranslationTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822ae828",
  null
  
)

export default component.exports